// One source for the requested capability scope and the parser's guarded-read prefix.
export const LOCKS_GUARDED_CONTENT_PATH = '/priv/app.locks/content/';

// Payment window recorded in newly published Locks criteria, in whole hours.
export const PAYKIT_PAYMENT_IN_HOURS = 24;
